<template>
    <div :id="id" class="row">
      <LmTextInput
        ref="inputFocus"
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.centerMapCoordinate[0]"
        @input="$emit('input', component)"
        label="Latitud Inicial"
        placeholder="-34.6037389"
      />
      <LmTextInput
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.centerMapCoordinate[1]"
        @input="$emit('input', component)"
        label="Longitud Inicial"
        placeholder="-58.3815704"
      />
      <LmTextInput
        :id="id + 'height'"
        help="Este ajuste no se podrá ver correctamente en la vista previa, por que el mapa necesita conocer la altura para poder mostrarse de manera correcta. Cuando el formulario sea guardado y visto en su vista final se verá correctamente."
        class="col-12 col-md-4"
        v-model="component.componentProps.height"
        @input="$emit('input', component)"
        label="Altura"
        placeholder="400px"
      />
      <div class="col-12 col-md-4">
        <label for="zoom">Zoom</label>
        <b-form-input
          id="zoom"
          v-model="component.componentProps.zoom"
          @input="$emit('input', component)"
          type="range"
          min="0"
          max="18"/>
          <div class="mt-2">Zoom: {{ component.componentProps.zoom }}</div>
      </div>
      <LmSelect
        :id="id + 'tiles'"
        class="col-12 col-md-4"
        v-model="component.componentProps.tile"
        :options="{
          content: [
            {value: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',text: 'Mapa'},
            {value: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', text: 'Satélite'},
            {value: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', text: 'Topográfico'}
          ]
        }"
        label="Tiles"
        @input="$emit('input', component)"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        label="Ancho vista escritorio"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  watch: {
    componentData () {
      this.component = this.componentData
    }
  }
}
</script>
